import type { FC } from 'react';

import { useApplication } from '@eneco/common/application';
import ComponentError from '@eneco/components/ui/ComponentError/ComponentError';

import { IDealPaymentForm } from './IDealPaymentForm';
import { IDealTransactionResult } from './IDealPaymentResult';


const IDealPaymentWrapper: FC = () => {
  const { searchParams } = useApplication();
  const encryptedPaymentId = searchParams.get('scope');
  const transactionId = encryptedPaymentId ? atob(encryptedPaymentId)?.split(':')[1] : null;
  const query = searchParams.get('query');
  if (!transactionId && !query && !searchParams.get('id')) {
    return <ComponentError />;
  }

  return transactionId && query ? (
    <IDealTransactionResult transactionId={transactionId} query={query} />
  ) : (
    <IDealPaymentForm />
  );
};

export default IDealPaymentWrapper;
